import { type ReactElement } from 'react'
import Header from '../../components/header/header'
import banner from './assets/banner.png'
import * as S from './checkout.styled'
import check from '../../assets/images/check.svg'
import appleStore from '../../assets/images/apple-store.svg'
import googlePlay from '../../assets/images/google-play.svg'
import { Link } from 'react-router-dom'
import { Footer } from '../../components/footer/footer'

export function Checkout (): ReactElement {
  return <>
    <Header className="blank" />
    <S.Main>
      <S.Container>
        <S.Banner>
          <img src={banner} alt="Cartão de TODOS Sonhos" />
        </S.Banner>
        <S.ContentContainer>
          <S.Content>
            <S.Header>
              <h1>Obrigado por fazer parte do Cartão de TODOS Sonhos!</h1>
              <small>Matrícula confirmada com sucesso!</small>
            </S.Header>
            <S.RegistrationContainer>
              <S.Registration>
                <small>O seu número de matrícula é:</small>
                <p><strong>SP287018272</strong></p>
              </S.Registration>
              <small>Guarde este número com carinho — ele é a sua porta de entrada para uma vida com mais saúde, economia e agora… mais sonhos realizados.</small>
            </S.RegistrationContainer>
            <S.TextContent>
              <h2>🩺 Você já pode aproveitar todos os benefícios em saúde:</h2>
              <ul>
                <li>
                  <img src={check} alt="" />
                  <span>Consultas médicas <strong>a partir de R$30,00</strong> em todo o Brasil</span>
                </li>
                <li>
                  <img src={check} alt="" />
                  <span><strong>Exames com 70%</strong> de desconto na rede credenciada</span>
                </li>
                <li>
                  <img src={check} alt="" />
                  <span>Atendimento facilitado e agendamento pelo <strong>nosso app ou site</strong></span>
                </li>
                <li>
                  <img src={check} alt="" />
                  Benefícios extensivos ao seu cônjuge e filhos de até 21 anos
                </li>
              </ul>
            </S.TextContent>
            <S.TextContent>
              <h2>✨ E com o Cartão de TODOS Sonhos, tem mais:</h2>
              <ul>
                <li>
                  <img src={check} alt="" />
                  Acesso à plataforma digital com livros e áudios
                </li>
                <li>
                  <img src={check} alt="" />
                  <span>Números da sorte para concorrer a <strong>1 carro por semana</strong></span>
                </li>
                <li>
                  <img src={check} alt="" />
                  <span> E mais: todo mês, você concorre a <strong>1 casa novinha!</strong></span>
                </li>
                <li>
                  <img src={check} alt="" />
                  Além disso, você pode ter seu sonho escolhido e realizado no programa Sabadão de TODOS, por meio da seleção de cartas enviadas por nossos filiados
                </li>
              </ul>
            </S.TextContent>
            <S.Link to="https://vivasorteoficial.com.br/autenticar" target="_blank" rel="noreferrer noopener">Acesse seu número da sorte</S.Link>
            <S.TextContent>
              <h2>🔔 Fique de olho!</h2>
              <p>
                Você receberá um e-mail com mais detalhes e o seu número da sorte.
                <br />
                Quer mais facilidade? Baixe nosso app!
              </p>
            </S.TextContent>
            <S.StoresContainer>
              <Link to="https://apps.apple.com/br/app/cart%C3%A3o-de-todos/id1536693230" target="_blank" rel="noreferrer noopener">
                <img src={appleStore} alt="Apple Store" />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.cartaodetodoswalletapp" target="_blank" rel="noreferrer noopener">
                <img src={googlePlay} alt="Google Play" />
              </Link>
            </S.StoresContainer>
            <S.TextContent>
              <p><strong>Agora que você é um filiado, um de nossos profissionais entrará em contato com você por telefone.</strong></p>
              <p>Nesse momento, você poderá incluir seus dependentes, como seus filhos de até 21 anos e seu cônjuge, para que todos aproveitem os benefícios do seu cartão.</p>
            </S.TextContent>
          </S.Content>
          <Footer />
        </S.ContentContainer>
      </S.Container>
    </S.Main>
  </>
}
